import { css } from "@emotion/react";
import { BG_MAIN } from "assets/Common";

export const DefaultLayoutStyle = {
  self: css`
    background: url(${BG_MAIN}) no-repeat;
    background-size: cover;
    background-position: center;
  `,
};
